import * as React from "react"

const SvgRightArrow = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23.073}
    height={12.595}
    viewBox="0 0 23.073 12.595"
    {...props}
  >
    <path
      d="M19.41 7.344H1.197a1.889 1.889 0 0 1-.509-.05.993.993 0 0 1-.683-1.11 1 1 0 0 1 .88-.916 3.132 3.132 0 0 1 .393-.014h18.153l.077-.106a1.012 1.012 0 0 1-.236-.131q-1.6-1.582-3.186-3.17a1.033 1.033 0 0 1-.318-1.094 1.047 1.047 0 0 1 1.682-.5 2.923 2.923 0 0 1 .23.221l4.979 4.985a1.065 1.065 0 0 1 0 1.69q-2.553 2.553-5.1 5.106a1.059 1.059 0 0 1-1.81-.494 1.02 1.02 0 0 1 .345-1.015q1.582-1.58 3.161-3.162a1.294 1.294 0 0 1 .228-.147Z"
      fill="#fff"
    />
  </svg>
)

export default SvgRightArrow
